import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Lightning02 = function Lightning02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M13.1556 3h-5.18c-.1615 0-.2423 0-.3136.0246a.45.45 0 0 0-.1681.104c-.054.0527-.09.125-.1623.2694l-3.78 7.56c-.1725.345-.2587.5175-.238.6578a.4503.4503 0 0 0 .1872.303C3.617 12 3.8098 12 4.1956 12h5.585l-2.7 9L18.0544 9.6198c.3702-.384.5554-.576.5662-.7402a.45.45 0 0 0-.1587-.3734C18.3362 8.4 18.0695 8.4 17.5361 8.4h-6.4055l2.025-5.4Z"
    })
  }));
};
export default Lightning02;